import { Outlet } from "react-router-dom";
import ScrollToTopOnRoute from "../components/global/ScrollToTopOnRoute";

function RootLayout() {
  return (
    <>
      <ScrollToTopOnRoute />
      <main id="main-content">
        <Outlet />
      </main>
    </>
  );
}

export default RootLayout;
